export const QueryParam = {
	Page: 'page',
	// Note(Filip): for now, we do not use pageSize; it is capped on the backend and the client will always use `DEFAULT_PAGE_SIZE = 20` for now.
	PageSize: 'pageSize',
	Country: 'country',
	State: 'state',
	Name: 'name',
	LocationSearch: 'locationSearch',
	SpecialtySearch: 'specialtySearch',
	SpecialtyGroup: 'specialtyGroup',
	Specialty: 'specialty',
	HcpType: 'hcpType',
	HcoType: 'hcoType',
	Hco: 'hco',
	IncludeInactive: 'includeInactive'
} as const;

export type QueryParams = {
	page: number;
	// pageSize: number;
	name: string;
	country: Array<string>;
	state: Array<string>;
	locationSearch: string;
	specialtySearch: string;
	specialtyGroup: Array<string>;
	specialty: Array<string>;
	hcpType: Array<string>;
	hcoType: Array<string>;
	hco: Array<string>;
	includeInactive: boolean;
};

// Initial order of the query params.
export const paramOrder = [
	QueryParam.Page,
	/*'QueryParam.PageSize'*/
	QueryParam.Name,
	QueryParam.LocationSearch,
	QueryParam.SpecialtySearch,
	QueryParam.Country,
	QueryParam.State,
	QueryParam.SpecialtyGroup,
	QueryParam.Specialty,
	QueryParam.HcpType,
	QueryParam.HcoType,
	QueryParam.Hco,
	QueryParam.IncludeInactive
] as const;
